module.exports = __webpack_public_path__ + "img/tag1.ff6717cf.png";